import { Injectable } from '@angular/core';
import {
  CallType,
  DownLawyerEntryValueGQL,
  ExportListGQL,
  FindListCallsGQL,
  ImportListGQL,
  ListsTableGQL,
  SwapAssistanceDownGQL,
  SwapAssistanceUpGQL,
  SwapSubstitutionDownGQL,
  SwapSubstitutionUpGQL,
} from '../../../generated/graphql';
import { Pagination } from '../../utils/Pagination';

@Injectable({
  providedIn: 'root',
})
export class ListService {
  constructor(
    private importListService: ImportListGQL,
    private listService: ListsTableGQL,
    private down: DownLawyerEntryValueGQL,
    private swapAssistanceUp: SwapAssistanceUpGQL,
    private swapSubstitutionUp: SwapSubstitutionUpGQL,
    private swapAssistanceDown: SwapAssistanceDownGQL,
    private swapSubstitutionDown: SwapSubstitutionDownGQL,
    private listsCallsService: FindListCallsGQL,
    private exportService: ExportListGQL
  ) {}

  list(pagination?: Pagination) {
    return this.listService.fetch({ pagination });
  }

  importList(file: File, id: number) {
    return this.importListService.mutate({ id, file });
  }

  restoreSubstitution(lawyer: number, list: number) {
    return this.down.mutate({ list, lawyer, substitution: -1, assistance: 0 });
  }

  restoreAssistance(lawyer: number, list: number) {
    return this.down.mutate({ list, lawyer, substitution: 0, assistance: -1 });
  }

  upAssistance(lawyer: number, list: number) {
    return this.swapAssistanceUp.mutate({ list, lawyer });
  }

  upSubstitution(lawyer: number, list: number) {
    return this.swapSubstitutionUp.mutate({ list, lawyer });
  }

  penalizeAssistance(lawyer: number, list: number) {
    return this.down.mutate({ list, lawyer, substitution: 0, assistance: 1 });
  }

  penalizeSubstitution(lawyer: number, list: number) {
    return this.down.mutate({ list, lawyer, substitution: 1, assistance: 0 });
  }

  downAssistance(lawyer: number, list: number) {
    return this.swapAssistanceDown.mutate({ list, lawyer });
  }

  downSubstitution(lawyer: number, list: number) {
    return this.swapSubstitutionDown.mutate({ list, lawyer });
  }

  listCalls(pagination: Pagination, list: number, type: CallType) {
    return this.listsCallsService.fetch({ id: list, pagination, type });
  }

  export(list: number) {
    return this.exportService.fetch({ list });
  }
}
